import React from 'react';
import TogglableUserList from '../../common/TogglableUserList';
import { useEventSpeakers } from '../../../../../../data/hooks/speakers/useEventSpeakers';

function InviteSpeakers(props) {
    const { eventId, selected, onChange } = props,
        allSpeakers = useEventSpeakers(eventId);

    return <TogglableUserList all={allSpeakers} selected={selected} onChange={onChange} />;
}

export default InviteSpeakers;
